import { render } from "./add-edit-user.vue?vue&type=template&id=c3ffd8f2"
import script from "./add-edit-user.vue?vue&type=script&lang=js"
export * from "./add-edit-user.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__